import React from 'react';

import { useWalletWithPositionsQuery } from '#/api/queries/walletPositionsQueries';

import BalanceStatsPanel from './BalanceStatsPanel';

export default function BalanceStatsPanelWithData({
  onlyCollateral,
  vaultManagerWalletOverride,
}: {
  onlyCollateral?: boolean;
  vaultManagerWalletOverride?: string;
}) {
  const { data: walletWithPositions } = useWalletWithPositionsQuery(
    true,
    undefined,
    vaultManagerWalletOverride
  );
  return (
    <BalanceStatsPanel
      walletWithPositions={walletWithPositions}
      onlyCollateral={onlyCollateral}
    />
  );
}
